import { Blockquote, Inset, Link, Text } from "@radix-ui/themes";


export default function Y2025M05() {

  return (
    <>
      <div className="container py-5">
        <div className='row'>
          <div className='col-lg-4'>
            <Inset clip="padding-box" side="top" pb="current">
              <img
                src="https://www.shadvala.org/img/interstices-2025-05-23.jpg"
                alt="Events"
                style={{
                  display: 'block',
                  objectFit: 'cover',
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'var(--gray-5)',
                }}
              />
              <Text as="p" mb="5" size="2">
                Photo by Jasmin Tahmaseb
              </Text>
            </Inset>
          </div>
        

          
          <div className='col-lg-8'>
            <div className="container">
              <div className='row py-3 border-top'>
                <div className='col'>
                  <Text as="p" mb="5" size="2" weight="bold">
                    23-25 May 2025, Labyrinth, Zagarolo (Italy)
                  </Text>
                </div>
              </div>
              <div className='row pb-3'>
                <div className='col'>
                  <Blockquote size="4" color>
                    Workshop  with Paul Stoller: <i>Knowledge Transmission and Ways of Living</i>
                  </Blockquote>
                  <Blockquote size="2" color>
                    <b>Project Transculturality</b>
                  </Blockquote>
                  <Blockquote size="2" color>
                    Center Interstices in collaboration with FAD
                  </Blockquote>
                </div>
              </div> 
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" size="3">
                    This workshop of the <i>Interstices</i> Center will set out to explore modalities of knowledge transmission and ways of living that differ from the mainstream discourse of the West. The debate will focus on spaces of interaction that cannot be easily standardized by the logic of (globalized) Westernization. It will not only bring various disciplines of knowledge to a fruitful dialogue on the motivations and effects of specific cultural practices but also to explore the subjects’ engagement in such practices, opening thus a space for a cosmo-political transformation of the Western paradigm for the sake of a “pluriverse”. 
                  </Text>
                </div>
              </div>
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" size="3">
                    <Link   href="https://www.shadvala.org/pdf/2025-05-Conception-Workshop-Knowledge-Transmission-and-Ways-of-Living.pdf" target="_blank">
                      Conception: Download PDF (0.13 MB) &nbsp;
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.50005 1.04999C7.74858 1.04999 7.95005 1.25146 7.95005 1.49999V8.41359L10.1819 6.18179C10.3576 6.00605 10.6425 6.00605 10.8182 6.18179C10.994 6.35753 10.994 6.64245 10.8182 6.81819L7.81825 9.81819C7.64251 9.99392 7.35759 9.99392 7.18185 9.81819L4.18185 6.81819C4.00611 6.64245 4.00611 6.35753 4.18185 6.18179C4.35759 6.00605 4.64251 6.00605 4.81825 6.18179L7.05005 8.41359V1.49999C7.05005 1.25146 7.25152 1.04999 7.50005 1.04999ZM2.5 10C2.77614 10 3 10.2239 3 10.5V12C3 12.5539 3.44565 13 3.99635 13H11.0012C11.5529 13 12 12.5528 12 12V10.5C12 10.2239 12.2239 10 12.5 10C12.7761 10 13 10.2239 13 10.5V12C13 13.1041 12.1062 14 11.0012 14H3.99635C2.89019 14 2 13.103 2 12V10.5C2 10.2239 2.22386 10 2.5 10Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg> 
                    </Link>
                  </Text>
                </div>
              </div>
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" size="3">
                    <Link   href="https://www.shadvala.org/pdf/2025-05-Program-Workshop-Knowledge-Transmission-and-Ways-of-Living.pdf" target="_blank">
                      Program: Download PDF (0.15 MB) &nbsp;
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.50005 1.04999C7.74858 1.04999 7.95005 1.25146 7.95005 1.49999V8.41359L10.1819 6.18179C10.3576 6.00605 10.6425 6.00605 10.8182 6.18179C10.994 6.35753 10.994 6.64245 10.8182 6.81819L7.81825 9.81819C7.64251 9.99392 7.35759 9.99392 7.18185 9.81819L4.18185 6.81819C4.00611 6.64245 4.00611 6.35753 4.18185 6.18179C4.35759 6.00605 4.64251 6.00605 4.81825 6.18179L7.05005 8.41359V1.49999C7.05005 1.25146 7.25152 1.04999 7.50005 1.04999ZM2.5 10C2.77614 10 3 10.2239 3 10.5V12C3 12.5539 3.44565 13 3.99635 13H11.0012C11.5529 13 12 12.5528 12 12V10.5C12 10.2239 12.2239 10 12.5 10C12.7761 10 13 10.2239 13 10.5V12C13 13.1041 12.1062 14 11.0012 14H3.99635C2.89019 14 2 13.103 2 12V10.5C2 10.2239 2.22386 10 2.5 10Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg> 
                    </Link>
                  </Text>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  )
}
